module.exports = __webpack_public_path__ + "img/om.ome32ff9c.svg";